import { Box, Button, ButtonBase, styled } from '@mui/material';

export const RadioClicksRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  overflow: 'hidden',
  padding: theme.spacing(0.2),
  backgroundColor: theme.palette.mode === 'dark' ? '#434e55' : '#ECEEF0',
  borderRadius: theme.shape.borderRadius,
  borderBottom: 'none',
  height: '30px',
}));

export const ScrollBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  scrollbarWidth: 'none',
  whiteSpace: 'nowrap',
  height: '30px',
  backgroundColor: theme.palette.mode === 'dark' ? '#434e55' : '#ECEEF0',
}));

export const RadioClicksButton = styled(Button)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.paper : 'white',
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  minWidth: 'auto',
  height: '100%',
}));

export const RadioClicksItem = styled(ButtonBase)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.paper : 'white',
  display: 'flex',
  borderRight: `1px solid ${theme.palette.divider}`,

  '&.assigned': {
    paddingX: 2,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    borderColor: `${theme.palette.error.light}`,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  '&.timestamp': {
    backgroundColor: 'transparent',
    border: 'none',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  '&.disabled': {
    color: theme.palette.text.disabled,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.first': {
    borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
  },
  '&.last': {
    borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
    border: 'none',
  },
  '&.first.last': {
    borderRadius: theme.shape.borderRadius,
  },
}));
